module.exports = __webpack_public_path__ + "static/fonts/lynkcotype-regular.28a216ee.otf";